import React from "react";
import GaugeChart from "react-gauge-chart";

function SpeedChart({ percentage }) {
  const percent = Math.min(Math.max(Number(percentage), 0), 100) / 100;

  return (
    <div>
      <GaugeChart
        id="gauge-chart4"
        nrOfLevels={5}
        arcPadding={0}
        cornerRadius={0}
        percent={percent}
        needleColor={"#5DA3E9"}
        marginInPercent={0}
        colors={[
          "rgba(255,17,0,1)",
          "rgba(255,165,0,1)",
          "rgba(255,204,0,1)",
          "rgba(0,161,6,1)",
          "rgba(0,104,4,1)",
        ]}
        hideText={true}
        animate={false}
      />
    </div>
  );
}

export default SpeedChart;
